import Overlay from 'ol/Overlay'
import { fromLonLat } from 'ol/proj'
import type OlMap from 'ol/Map'
import { parseCoordinate } from '../map/coordinates'

/**
 * Contents of the toolbar's "Go to" panel (PRD P1.3): parse lat/lon (decimal
 * or DMS), animate the view there and drop a marker overlay. Repeated go-tos
 * move the same marker. The panel belongs to `mapToolbar` (T4) — which is also
 * why the placeholder no longer repeats "Go to": the button already says it.
 */
export function renderGotoBar(panel: HTMLElement, map: OlMap): void {
  panel.innerHTML = `
    <input type="text" id="goto-input" class="goto-input" placeholder="45.5017, -73.5673 or 45°30'N 73°34'W" aria-label="Go to coordinates" />
    <button type="button" class="measure-btn" id="goto-go">Go</button>`

  const input = panel.querySelector('#goto-input') as HTMLInputElement
  const button = panel.querySelector('#goto-go') as HTMLButtonElement

  const markerEl = document.createElement('div')
  markerEl.className = 'goto-marker'
  const marker = new Overlay({ element: markerEl, positioning: 'bottom-center' })
  map.addOverlay(marker)

  function go(): void {
    const parsed = parseCoordinate(input.value)
    input.classList.toggle('goto-input--invalid', parsed === null)
    if (!parsed) return
    const target = fromLonLat([parsed.lon, parsed.lat])
    marker.setPosition(target)
    const view = map.getView()
    view.animate({ center: target, zoom: Math.max(view.getZoom() ?? 0, 12), duration: 400 })
  }

  button.addEventListener('click', go)
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') go()
    else input.classList.remove('goto-input--invalid')
  })
}
